import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
class SectionTemplateResource extends BaseResource {
    pk() {
        return this.sectionTemplateId?.toString();
    }
}
SectionTemplateResource.urlRoot = apiResourceUrl("sectiontemplate");
export { SectionTemplateResource };
//# sourceMappingURL=SectionTemplateResource.js.map